import { useEventClient } from '@eventbrite/event-renderer';

const ORGANIZERS_LIMIT = 18;
const getUniqueValues = (organizerIds) => [...new Set(organizerIds)];
const removeNullValues = (organizerId) => organizerId;

const getUniqueOrganizerIds = (eventArray) => {
    return getUniqueValues(
        eventArray
            .map((eventData) => eventData.organizerId)
            .filter(removeNullValues),
    ).slice(0, ORGANIZERS_LIMIT);
};

const parseEditorialEvents = (data) => {
    if (!data || data.events.length === 0) {
        return [];
    }

    return getUniqueOrganizerIds(data.events);
};

const parsePersonalEvents = (data) => {
    if (!data || data?.pages?.[0].events.length === 0) {
        return [];
    }

    const flatEvents = data.pages.reduce((memo, group) => {
        return [...memo, ...group.events];
    }, []);

    return getUniqueOrganizerIds(flatEvents);
};

export const useOrganizerIds = (isQuality, collectionId) => {
    const key = isQuality
        ? 'editorial-collection-events'
        : ['personal-collection-events', collectionId];
    const eventClient = useEventClient();
    const data = eventClient.getQueryData(key);

    const parser = isQuality ? parseEditorialEvents : parsePersonalEvents;
    const organizerIds = parser(data);

    return organizerIds;
};
